<template>
    <div class="flex items-center select-none">
        <a href="#" class="flex items-center text-lg text-gray-300 hover:text-gray-300 border border-gray-300 rounded overflow-hidden" @click.prevent="toggleType">
            <div class="px-2 py-1" :class="{ 'bg-gray-300 text-white': 'compact' === type, 'hover:text-gray-400 hover:bg-gray-200': 'compact' !== type }">
                <span class="far fa-th fa-fw fa-sm"></span>
            </div>
            <div class="px-2 py-1" :class="{ 'bg-gray-300 text-white': 'detailed' === type, 'hover:text-gray-400 hover:bg-gray-200': 'detailed' !== type }">
                <span class="far fa-th-list fa-fw fa-sm"></span>
            </div>
        </a>
    </div>
</template>

<script>
    import { assign } from 'lodash-es';

    export default {
        props: {
            value: {
                type: String,
                required: false,
            },
        },

        data() {
            return {
                type: this.value || 'compact',
            };
        },

        watch: {
            value() {
                this.type = this.value;
            },

            type() {
                this.$emit('input', this.type);
            },
        },

        methods: {
            toggleType() {
                if ('detailed' === this.type) {
                    this.type = 'compact';

                    return;
                }

                this.type = 'detailed';
            },
        },
    };
</script>
